import layout1Settings from "./layout-1/settings";
import layout2Settings from "./layout-2/settings";

export const layoutSettings = {
  layout1Settings,
  layout2Settings,

  dir: "ltr", // ltr, rtl
  activeLayout: "layout1", // layout1, layout2

  footer: { show: true },
  customizer: { show: false, open: true }
};
